import React, { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { UserHeader } from "./UserHeader";

type LayoutProps = {
  children: ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="overflow-hidden h-dvh">
    {/* <div className="p-5 overflow-hidden"> */}
    {/* <div className="p-5 h-dvh overflow-hidden"> */}
      <UserHeader />
      <main className="overflow-y-auto bg-black footer-calc">
      {/* <main className="overflow-y-auto footer-calc"> */}
      {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
